export default "__VITE_ASSET__hrNhWb3K__"